import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useState, forwardRef, InputHTMLAttributes } from "react";
import { Label } from "../Text/Text";
import { cn } from "@/lib/utils";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errors?: string;
}
const Passwordinput = forwardRef<HTMLInputElement, Props>(
  ({ errors, label, className, ...props }, ref) => {
    const [ispassword, setispassword] = useState(true);
    const [inputfocus, setinputfocus] = useState(false);
    return (
      <div className="grid gap-1">
        {label && <Label>{label}</Label>}
        <div
          className={`flex items-center border focus:border-2 dark:bg-grey-500 dark:border-0 border-gray-300 rounded ${
            inputfocus && "border-indigo-400 ring-1 ring-indigo-400"
          }`}
        >
          <input
            ref={ref}
            {...props}
            autoComplete="off"
            onBlur={() => setinputfocus(false)}
            onClick={() => setinputfocus(true)}
            // className="p-2 rounded-sm w-full focus:outline-none border border-r-0 focus:border-blue-500  border-gray-400 "
            type={ispassword ? "password" : "text"}
            className={cn(
              "p-2.5  border-gray-300 flex-1 dark:text-white border-0 dark:bg-grey-500 rounded focus:outline-none outline-none ",
              className
            )}
          />
          <div
            className={` p-2 border-0 bg-white dark:bg-grey-500 border-l-0  rounded-r `}
          >
            {ispassword ? (
              <EyeIcon
                onClick={() => setispassword((prev) => !prev)}
                className="h-4 w-4  text-gray-500 cursor-pointer"
              />
            ) : (
              <EyeSlashIcon
                onClick={() => setispassword((prev) => !prev)}
                className="h-6 w-6  text-gray-500 cursor-pointer"
              />
            )}
          </div>
        </div>
        {errors && (
          <span className="text-red-500 text-xs font-medium">{errors}</span>
        )}
      </div>
    );
  }
);

export default Passwordinput;
